import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typography } from 'antd';

const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TitleWrapper = styled.h2`
  margin-top: 1em;
  margin-bottom: 1em;
  font-weight: 600;
`;

const ContentWrapper = styled.div`
  text-align: center;
`;

function GenericError({ title, children, imageSrc }) {
  return (
    <ErrorWrapper>
      <img src={imageSrc} alt="" />
      <TitleWrapper>{title}</TitleWrapper>
      <ContentWrapper>
        <Typography.Text type="secondary">{children}</Typography.Text>
      </ContentWrapper>
    </ErrorWrapper>
  );
}

GenericError.defaultProps = {
  title: 'Ooops!',
  imageSrc:
    'https://storage.googleapis.com/static-files-4fdd9378-835d-40e4-b124-36699ae5cc08/estrategico/banner/ana-ops.svg',
};

GenericError.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  imageSrc: PropTypes.string,
};

export default GenericError;
